/** The API's error message from a failed $fetch, or the fallback. */
export function fetchErrorMessage(err: unknown, fallback = 'Something went wrong. Try again.'): string {
  return (err as { data?: { message?: string } } | null)?.data?.message || fallback
}
